import { useState } from 'react';
import { Field } from '@sitecore-content-sdk/nextjs';
import { AnswerProps, QuestionProps } from 'lib/hooks/open-scheduling-wizard/open-scheduling-types';

/**
 * Manages the initial question state for the open scheduling wizard.
 *
 * This hook is responsible for the "Next", "Restart", and "showIframe" logic.
 *
 * *Note*: This hook requires a user answer at least one question in order
 * to set `visitTypeID`.
 **/
export const useWizardQuestionWidgetState = (startingQuestion?: QuestionProps) => {
  const [currentQuestion, setCurrentQuestion] = useState<QuestionProps | null>(
    startingQuestion || null
  );
  const [isFirstQuestion, setIsFirstQuestion] = useState(true);
  const [visitTypeID, setVisitTypeID] = useState<string | null>(null);
  const [showIframe, setShowIframe] = useState(false);

  // Set the next set of questions in state until the user has selected a visitTypeID
  const handleAnswerClick = (answer: AnswerProps) => {
    const visitTypeID = answer?.fields?.answerLink?.fields?.visitTypeID as Field<string>;
    if (visitTypeID) {
      setShowIframe(true);
      setVisitTypeID(visitTypeID.value as string);
    } else {
      setShowIframe(false);
      setCurrentQuestion(answer?.fields?.answerLink as QuestionProps);
      setIsFirstQuestion(false);
    }
  };

  const handleStartOver = () => {
    setCurrentQuestion(startingQuestion || null);
    setShowIframe(false);
    setIsFirstQuestion(true);
    setVisitTypeID(null);
  };

  return {
    currentQuestion,
    isFirstQuestion,
    visitTypeID,
    showIframe,
    handleAnswerClick,
    handleStartOver,
  };
};
